// @flow
import {addLocaleData} from 'react-intl';
import type {LanguageKey} from '../config/LanguageConfig';

const getEnLocaleData = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-en" */ 'react-intl/locale-data/en');
const getFrLocaleData = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-fr" */ 'react-intl/locale-data/fr');
const getDeLocaleData = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-de" */ 'react-intl/locale-data/de');
const getNlLocaleData = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-nl" */ 'react-intl/locale-data/nl');
const getLuLocaleData = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-lu" */ 'react-intl/locale-data/lu');
const getPtLocaleData = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-pt" */ 'react-intl/locale-data/pt');

const getEnMessages = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-en" */ './en');
const getFrMessages = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-fr" */ './fr');
const getDeMessages = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-de" */ './de');
const getNlMessages = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-nl" */ './nl');
const getLuMessages = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-lu" */ './lu');
const getPtMessages = () =>
   import(/* webpackMode: "lazy", webpackChunkName: "intl-pt" */ './pt');

function getLocaleDataAndMessagesFromLocale(locale: LanguageKey): Promise<any> {
   switch (locale) {
      case 'fr':
         return Promise.all([getFrLocaleData(), getFrMessages()]);
      case 'de':
         return Promise.all([getDeLocaleData(), getDeMessages()]);
      case 'nl':
         return Promise.all([getNlLocaleData(), getNlMessages()]);
      case 'lu':
         return Promise.all([getLuLocaleData(), getLuMessages()]);
      case 'pt':
         return Promise.all([getPtLocaleData(), getPtMessages()]);
      default:
         return Promise.all([getEnLocaleData(), getEnMessages()]);
   }
}

export function getMessagesByLocaleAndAddLocaleData(locale: LanguageKey) {
   return getLocaleDataAndMessagesFromLocale(locale).then(
      ([localeData, messages]) => {
         addLocaleData(localeData.default);
         return {
            ...messages.default,
         };
      },
   );
}
